import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("UI crash", error, info);
    const msg = String(error?.message || error);
    const domMutation = /removeChild|insertBefore|not a child of this node/i.test(msg);
    if (domMutation && !sessionStorage.getItem("ui_crash_reloaded")) {
      sessionStorage.setItem("ui_crash_reloaded", "1");
      window.location.reload();
      return;
    }
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-error`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ message: msg.slice(0, 500), stack: String(info?.componentStack || "").slice(0, 1500), url: window.location.href }),
    }).catch(() => {});
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div data-testid="app-error-screen" className="min-h-screen grid place-items-center bg-black text-white px-6 text-center">
        <div>
          <div className="font-display text-3xl tracking-wider">Algo salió mal</div>
          <p className="text-neutral-400 text-sm mt-2">Recargá la página para continuar.</p>
          <button data-testid="app-error-reload" onClick={() => (window.location.href = "/")} className="btn-primary mt-5 px-5 py-2.5 rounded-md">
            Volver al inicio
          </button>
        </div>
      </div>
    );
  }
}
